// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-70percent[data-v-bc475582] {\n  width: 70%;\n}\n", ""]);
// Exports
module.exports = exports;
